export const headerHeight = '72px';
export const linkHeaderHeight = '60px';
export const linkResponsiveHeaderHeight = '102px';
